import { c as _c } from "react/compiler-runtime";
import { useSearchPageMapData } from "@/hooks/search";
import { useUrlFilters } from "@/hooks/use-url-filters";
import { MapItemWithCoodId } from "@/types/search";
import { useMemo } from "react";

/**
 * Custom hook to determine SEO banner visibility and calculate total properties count
 * Shared logic between desktop and mobile search layouts
 */
export function useSEOBannerVisibility() {
  const $ = _c(5);
  const {
    filters
  } = useUrlFilters();
  const mapData = useSearchPageMapData(_temp);
  let t0;
  bb0: {
    if (!mapData || mapData.length === 0) {
      t0 = 0;
      break bb0;
    }
    let t1;
    if ($[0] !== mapData) {
      t1 = mapData.reduce(_temp2, 0);
      $[0] = mapData;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    t0 = t1;
  }
  const totalPropertiesCount = t0;
  const propertyType = filters.propertyType;
  const shouldShowSeoBanner = !propertyType || propertyType === "apartment" || propertyType === "villa" || propertyType === "house";
  let t1;
  if ($[2] !== shouldShowSeoBanner || $[3] !== totalPropertiesCount) {
    t1 = {
      shouldShowSeoBanner,
      totalPropertiesCount
    };
    $[2] = shouldShowSeoBanner;
    $[3] = totalPropertiesCount;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
function _temp2(total, mapItem) {
  return total + (mapItem.sups?.length || 0);
}
function _temp(state) {
  return state.mapData;
}